var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "the-header" },
    [
      _c("div", { staticClass: "the-header__sticky-line" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(_setup.TheHeaderLine, {
              attrs: {
                "site-logo": _setup.siteLogo,
                "without-analyses-cart": _setup.withoutAnalysesCart,
                "analyses-count-in-cart": _setup.analysesCountInCart,
                "data-qa": "the_header_line",
              },
              on: { "header:click-hamburger-btn": _setup.handleClickHamburger },
            }),
            _vm._v(" "),
            _c(_setup.CoreSearch, {
              staticClass: "mt-2",
              on: { "click-search-btn": _setup.handleShowDialog },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(_setup.SearchDialog, {
        model: {
          value: _setup.isVisibleSearchDialog,
          callback: function ($$v) {
            _setup.isVisibleSearchDialog = $$v
          },
          expression: "isVisibleSearchDialog",
        },
      }),
      _vm._v(" "),
      _c(_setup.SideMenu, {
        attrs: {
          "expert-url": _setup.expertUrl,
          "available-languages": _setup.availableLanguages,
          town: _setup.transDynamic(
            _setup.searchData.location.town,
            `name,${_setup.language},${_setup.needTranslate}`
          ),
          "town-select-url": _setup.townSelectUrl,
          projects: _setup.projects,
          "personal-area-url": _setup.personalAreaUrl,
        },
        model: {
          value: _setup.isSideMenuActive,
          callback: function ($$v) {
            _setup.isSideMenuActive = $$v
          },
          expression: "isSideMenuActive",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }